<template>
  <div>
    <el-alert
      title="工具编码在本企业内唯一。启用后才能挂到维保工单的工具需求上。"
      type="info" :closable="false" show-icon style="margin-bottom:12px"
    />
    <div class="toolbar">
      <el-input v-model="query.toolNumber" clearable placeholder="编码" style="width:140px" @keyup.enter.native="search" />
      <el-input v-model="query.toolName" clearable placeholder="名称" style="width:140px" @keyup.enter.native="search" />
      <el-input v-model="query.toolCategory" clearable placeholder="类别" style="width:120px" @keyup.enter.native="search" />
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
    </div>
    <el-table :data="list" border v-loading="loading">
      <el-table-column prop="toolNumber" label="编码" width="140" />
      <el-table-column prop="toolName" label="名称" min-width="160" />
      <el-table-column prop="toolCategory" label="类别" width="120" />
      <el-table-column prop="unitName" label="单位" width="90" />
      <el-table-column prop="producer" label="厂家" width="120" />
      <el-table-column prop="serialNumber" label="序列号" width="120" />
      <el-table-column label="启用" width="80" align="center">
        <template slot-scope="{ row }">
          <el-tag size="small" :type="row.active === '1' ? 'success' : 'info'">{{ row.active === '1' ? '是' : '否' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row.toolId)">修改</el-button>
          <el-button type="text" style="color:#ef4444" @click="onDelete(row.toolId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination :total="total" :page="page" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]" @current-change="onPage" @size-change="onSize" />

    <el-dialog :title="form.toolId ? '修改工具' : '新增工具'" :visible.sync="visible" width="560px" :close-on-click-modal="false">
      <el-form :model="form" label-width="100px">
        <el-form-item label="编码"><el-input v-model="form.toolNumber" /></el-form-item>
        <el-form-item label="名称"><el-input v-model="form.toolName" /></el-form-item>
        <el-form-item label="类别"><el-input v-model="form.toolCategory" /></el-form-item>
        <el-form-item label="单位">
          <el-select v-model="form.unit" filterable clearable style="width:100%">
            <el-option v-for="u in units" :key="u.id" :label="u.dictLabel" :value="String(u.id)" />
          </el-select>
        </el-form-item>
        <el-form-item label="厂家"><el-input v-model="form.producer" /></el-form-item>
        <el-form-item label="库存号"><el-input v-model="form.inventoryNumber" /></el-form-item>
        <el-form-item label="序列号"><el-input v-model="form.serialNumber" /></el-form-item>
        <el-form-item label="说明"><el-input v-model="form.description" type="textarea" :rows="2" /></el-form-item>
        <el-form-item label="启用"><el-switch v-model="form.active" active-value="1" inactive-value="0" /></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import { listTool, getTool, saveTool, updateTool, deleteTool } from '../../api/tool'
import { listDictOptions } from '../../api/dict'

function emptyForm() {
  return {
    toolId: '', toolNumber: '', toolName: '', toolCategory: '', unit: '',
    producer: '', inventoryNumber: '', serialNumber: '', description: '', active: '1'
  }
}

export default {
  components: { ListPagination },
  data() {
    return {
      query: { toolNumber: '', toolName: '', toolCategory: '' },
      list: [], total: 0, page: 1, pageSize: 20, loading: false, saving: false, visible: false,
      form: emptyForm(), units: []
    }
  },
  created() {
    this.load()
    listDictOptions('UNIT').then(res => { this.units = res.data || [] }).catch(() => {})
  },
  methods: {
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    load() {
      this.loading = true
      listTool({
        currentPage: this.page, pageSize: this.pageSize,
        toolNumber: this.query.toolNumber, toolName: this.query.toolName, toolCategory: this.query.toolCategory
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    openEdit(id) {
      if (!id) {
        this.form = emptyForm()
        this.visible = true
        return
      }
      getTool(id).then(res => {
        const d = res.data || {}
        this.form = {
          toolId: d.toolId, toolNumber: d.toolNumber, toolName: d.toolName,
          toolCategory: d.toolCategory || '', unit: d.unit || '', producer: d.producer || '',
          inventoryNumber: d.inventoryNumber || '', serialNumber: d.serialNumber || '',
          description: d.description || '', active: d.active || '1'
        }
        this.visible = true
      })
    },
    submit() {
      if (!this.form.toolNumber || !this.form.toolName) { this.$message.warning('请填写编码和名称'); return }
      this.saving = true
      const req = this.form.toolId ? updateTool(this.form) : saveTool(this.form)
      req.then(() => {
        this.$message.success('保存成功')
        this.visible = false
        this.search()
      }).finally(() => { this.saving = false })
    },
    onDelete(id) {
      this.$confirm('确定删除?', '提示', { type: 'warning' }).then(() => {
        deleteTool([id]).then(() => { this.$message.success('已删除'); this.load() })
      }).catch(() => {})
    }
  }
}
</script>
